(function () {
  // A fixed number of static copies only tiles cleanly up to some screen
  // width — wider than that and the loop runs out of content mid-scroll,
  // showing a gap/jump right as it resets. Instead: duplicate the base
  // content until one "half" is at least as wide as the viewport, then
  // duplicate that whole half once more so the track is exactly two
  // identical halves. Animating from 0 to -50% then always has a full
  // viewport's worth of content on screen, and the loop back to 0 lands on
  // a pixel-identical frame — no visible seam, at any screen size.
  const PX_PER_SECOND = 60;

  function setUpMarquee(track) {
    if (!track.dataset.original) {
      track.dataset.original = track.innerHTML;
    }
    const original = track.dataset.original;

    track.style.animation = "none";
    track.innerHTML = original;

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return;
    }

    while (track.scrollWidth < window.innerWidth) {
      track.insertAdjacentHTML("beforeend", original);
    }
    const halfWidth = track.scrollWidth;
    track.insertAdjacentHTML("beforeend", track.innerHTML);

    const duration = halfWidth / PX_PER_SECOND;
    track.style.animation = `announcement-bar-scroll ${duration}s linear infinite`;
  }

  function init() {
    document.querySelectorAll(".announcement-bar__track").forEach(setUpMarquee);
  }

  init();

  // Re-run on resize (not just once) since a viewport widened past the
  // built loop's half-width would reintroduce the same gap/jump.
  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(init, 200);
  });
})();
